// extracted by mini-css-extract-plugin
export default {"LoginLayout_body":"Loginlayout_LoginLayout_body__bgPSm"};